import FaqGutContent from './FaqGutContent'

export default FaqGutContent
